import {RsvpQuestion} from '../../models/rsvp-question';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';
import {RsvpQuestionTransformer} from '../../helpers/subtypes/rsvp-question-transformer';

@inheritSerialization(LoadableState)
export class RsvpQuestionsState extends LoadableState {
  public static readonly key = 'RsvpQuestionsState';

  @autoserializeAs(RsvpQuestionTransformer, 'rsvpQuestions')
  public rsvpQuestions: RsvpQuestion[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError;
}
